import axios from 'axios';

const SCRAPBOARD_MANAGER_API = 'api/scrapboard-manager';

export default class ScrapboardManagerService {
  constructor() {}

  saveScrap(documents) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(SCRAPBOARD_MANAGER_API + '/saveScrap', documents)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  saveScrapTemp(documents) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(SCRAPBOARD_MANAGER_API + '/saveScrapTemp', documents)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  recreateScrapboard(connectomeId) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(SCRAPBOARD_MANAGER_API + '/reCreateScrapboard')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
}
